export { default } from 'navigation/layouts/claim-points-layout';
